export enum Units {
  Kg = "кг",
  Piece = "шт",
  Litr = "л",
  Dose = "доз",
  Set = "комп",
  Package = "упак",
  SowingUnit = "п.е.",
}
